import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Actions, ofActionSuccessful, Store } from '@ngxs/store';
import { Logout } from '@pharvio/accounts/admin-account/data-access';
import { ResetPosSession } from '@pharvio/pos/data-access';

@Injectable({ providedIn: 'root' })
export class PwaCacheService {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);
  private readonly destroyRef = inject(DestroyRef);

  init(): void {
    this.actions$
      .pipe(
        ofActionSuccessful(Logout),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        // Shared terminals: carts and the last sale must not leak to the next cashier.
        this.store.dispatch(new ResetPosSession());
        void this.clearDataCaches();
      });
  }

  /**
   * Clears Angular SW data caches on logout so customer/order data
   * from the previous session doesn't leak to the next user.
   * Leaves app-shell asset caches intact for fast re-login.
   */
  private async clearDataCaches(): Promise<void> {
    if (!('caches' in window)) return;
    try {
      const keys = await caches.keys();
      await Promise.all(
        keys
          .filter((k) => k.includes(':data:'))
          .map((k) => caches.delete(k))
      );
    } catch {
      // Cache clearing is best-effort; never block logout.
    }
  }
}
